export * from './about/about.page';
export * from './about/pages/privacyPolicy/privacyPolicy.page';
export * from './about/pages/releaseNotes/releaseNotes.page';
export * from './apply/pages/apply1WhatYouGet/apply1WhatYouGet.page';
export * from './apply/pages/apply2ApplicationForm/apply2ApplicationForm.page';
export * from './apply/pages/apply3LoginCredentials/apply3LoginCredentials.page';
export * from './apply/pages/apply4QuickStart/apply4QuickStart.page';
export * from './about/pages/termsOfService/termsOfService.page';
export * from './about/pages/version/version.page';

export * from './accessDenied/accessDenied.page';
export * from './account/account.page';
export * from './account/pages/accountProfile/accountProfile.page';
export * from './account/pages/order/order.page';
export * from './account/pages/orders/orders.page';
export * from './campaignOptout/campaignOptout.page';
export * from './cancel/cancel.page';
export * from './dashboard/dashboard.page';
export * from './help/help.page';
export * from './help/pages/tutorials/tutorials.page';
export * from './help/pages/contactUs/contactUs.page';
export * from './help/pages/feedback/feedback.page';
export * from './help/pages/introduction/introduction.page';
export * from './help/pages/messageCenter/messageCenter.page';
export * from './help/pages/message/message.page';
export * from './login/login.page';

// export * from './marketing/marketing.page';
export * from './marketing/pages/customers/customers.page';
export * from './marketing/pages/campaigns/campaigns.page';
export * from './marketing/pages/campaigns/pages/campaign/campaign.page';
export * from './marketing/pages/campaignFormatSelector/campaignFormatSelector.page';
export * from './marketing/pages/campaignHosting/campaignHosting.page';
export * from './marketing/pages/campaignMessage/campaignMessage.page';
export * from './marketing/pages/campaignIncentiveSets/pages/campaignIncentiveSet/campaignIncentiveSet.page';
export * from './marketing/pages/campaignIncentiveSets/campaignIncentiveSets.page';
export * from './marketing/pages/campaignIncentives/campaignIncentives.page';
export * from './marketing/pages/campaignIncentive/campaignIncentive.page';

export * from './managerSettings/managerSettings.page';
export * from './managerSettings/pages/dealership/dealership.page';
export * from './managerSettings/pages/user/user.page';
export * from './managerSettings/pages/users/users.page';
export * from './managerSettings/pages/shuttle/shuttle.page';
export * from './managerSettings/pages/shuttles/shuttles.page';
export * from './managerSettings/pages/serviceAreas/serviceAreas.page';
export * from './managerSettings/pages/serviceAreaSingle/serviceAreaSingle.page';
export * from './managerSettings/pages/serviceAreaMultiple/serviceAreaMultiple.page';

export * from './managerSettings/pages/ticketCreated/ticketCreated.page';
export * from './managerSettings/pages/dropoffAllAboard/dropoffAllAboard.page';
export * from './managerSettings/pages/dropoffCompleted/dropoffCompleted.page';
export * from './managerSettings/pages/pickupApproaching/pickupApproaching.page';
export * from './managerSettings/pages/pickupArrived/pickupArrived.page';
export * from './managerSettings/pages/pickupCompleted/pickupCompleted.page';
// export * from './managerSettings/pages/cacheLoginCreds/cacheLoginCreds.page';

export * from './marketing/marketing.page';

export * from './navigation/pages/navigation1ShuttleSelection/navigation1ShuttleSelection.page';
export * from './navigation/pages/navigation2Attendance/navigation2Attendance.page';
export * from './navigation/pages/navigation3StartRoute/navigation3StartRoute.page';
export * from './navigation/pages/navigation4ControlPanel/navigation4ControlPanel.page';
export * from './navigation/pages/navigation5Congratulations/navigation5Congratulations.page';

export * from './reports/pages/report1Type/report1Type.page';
export * from './reports/pages/report2Parameters/report2Parameters.page';
export * from './reports/pages/report3View/report3View.page';

export * from './showCampaign/showCampaign.page';

export * from './routes/pages/routeView/routeView.page';
export * from './routes/routes.page';
export * from './routes/pages/route1ShuttleSelection/route1ShuttleSelection.page';
export * from './routes/pages/route2TicketSelection/route2TicketSelection.page';
export * from './routes/pages/route3Locations/route3Locations.page';
export * from './routes/pages/route4Ordering/route4Ordering.page';
export * from './routes/pages/route5Verification/route5Verification.page';
export * from './routes/pages/route6Save/route6Save.page';
export * from './routes/pages/route7Notification/route7Notification.page';
export * from './routes/pages/route8Congratulations/route8Congratulations.page';

export * from './satisfactionPage1/satisfactionPage1.page';
export * from './satisfactionPage2/satisfactionPage2.page';
export * from './tickets/tickets.page';
export * from './tickets/pages/ticket1Passenger/ticket1Passenger.page';
export * from './tickets/pages/ticket2Destination/ticket2Destination.page';
export * from './tickets/pages/ticket3Save/ticket3Save.page';
export * from './tracker/tracker.page';
export * from './tracker/pages/tracker1HistoricalFilter/tracker1HistoricalFilter.page';
export * from './tracker/pages/tracker2HistoricalTrips/tracker2HistoricalTrips.page';
export * from './tracker/pages/tracker3HistoricalRoutes/tracker3HistoricalRoutes.page';
export * from './tracker/pages/trackerLive/trackerLive.page';
export * from './userSettings/userSettings.page';
export * from './welcome/welcome.page';
// export * from './services/reportFactory.service';
// export * from './services/reportFormatter.service';
// export * from './services/tripActualLocation.service';
// export * from './services/vectors.service';


// // export * from './campaignCoupons.service';
// // export * from './generateData.service';
// // export * from './customers/customers.service';
// // export * from './reports/reportCustomerDetails.service';
// // export * from './reports/reportDriverSummary.service';
// // export * from './reports/reportServiceAdvisorSummary.service';
// // export * from './reports/reportServiceAreasRaw.service';
// // export * from './reports/reportShuttlesRaw.service';
// // export * from './reports/reportSummaryRaw.service';
// // export * from './reports/reportUsersRaw.service';
// // export * from './serviceAreas.service';
// // export * from './smsSentMessages.service';
// // export * from './reports/reportAccountProfileRaw.service';

// export * from './services/campaigns.service';
// export * from './services/campaignIncentives.service';
// export * from './services/campaignIncentiveSets.service';
// export * from './services/dashboard.service';
// export * from './services/geocoder.service';
// export * from './services/menu.service';             // TODO: This belongs in shared/services
// export * from './services/navigationHelper.service';
// export * from './services/pickupQueue.service';
// export * from './services/pickupRequests.service';
// export * from './services/pickupResponses.service';
// export * from './services/reportCampaignSummary.service';
// export * from './services/reportSmsDetail.service';
// export * from './services/reportTicketDetail.service';
// export * from './services/reportTripSummary.service';
// export * from './services/routes.service';
// export * from './services/satisfaction.service';
// export * from './services/shuttleMovement.service';
// export * from './services/shuttles.service';
// export * from './services/tickets.service';
